<button
  type="button"
  [class]="cssClass"
  [disabled]="disabled()"
  [attr.aria-label]="label()"
  [attr.title]="label()"
>
  <ng-content />
</button>
